import { configureStore } from '@reduxjs/toolkit'

// immered reducers
import auth from './reducers/auth'
import sessions from './reducers/sessions'
import reports from './reducers/reports'
import summons from './reducers/summons'
import endusers from './reducers/endusers'
import tours from './reducers/tours'
import web from './reducers/web'
import zones from './reducers/zones'
import trackers from './reducers/trackers'
import panics from './reducers/panics'

// middlewares
import thunk from 'redux-thunk'
import logger from 'redux-logger'

// RTK Apis
import { apiPublic } from '../repositories/restfuls/apis/api.public'
import { apiVer4 } from '../repositories/restfuls/apis/api.v4.x'

// RTK Reducers
import { reducers } from 'repositories/redux'

// Create store using RTK
const store = configureStore({
  reducer: {
    auth,
    sessions,
    reports,
    summons,
    endusers,
    tours,
    web,
    zones,
    trackers,
    panics,
    ...reducers,
    // RTK Query Reducers
    [apiPublic.reducerPath]: apiPublic.reducer,
    [apiVer4.reducerPath]: apiVer4.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    window.conf?.log === true
      ? getDefaultMiddleware().concat(
          thunk,
          logger,
          apiPublic.middleware,
          apiVer4.middleware
        )
      : getDefaultMiddleware().concat(
          thunk,
          apiPublic.middleware,
          apiVer4.middleware
        ),
  devTools:
    window.conf?.devTools === true || process.env.NODE_ENV !== 'production', // Keep DevTools enabled in dev mode
})

export default store
